<template>
	<div class="page">
		<div class="pageTitleBox">
			<div class="boxNameL">
				编辑会员
			</div>
			<div class="boxNameR">
				<el-button type="warning" @click="$router.back()" size="small">返回</el-button>
			</div>
		</div>
		<div class="form" >
			<div class="tit">
				<div class="titL">基本信息</div>
				<div class="titR"></div>
			</div>
			<!-- box1 -->
			<div class="con">
				<el-form :inline="true" :model="userDetail.basic_info" class="demo-form-inline" ref="form" :rules="rules">
					<el-row>
						<el-col :span="6" >
							<el-form-item label="姓名：" prop="nick_name" :label-width="formLabelWidth">
								<el-input v-model="userDetail.basic_info.nick_name" placeholder="请输入姓名"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="5">
							<el-form-item label="性别：" :label-width="formLabelWidth">
								<el-radio-group v-model="userDetail.basic_info.sex">
									<el-radio :label="'男'">男</el-radio>
									<el-radio :label="'女'">女</el-radio>
								</el-radio-group>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="手机号码：" prop="user_mobile" :label-width="formLabelWidth">
								<el-input v-model="userDetail.basic_info.user_mobile" placeholder="请输入手机号码"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="邮箱：" :label-width="formLabelWidth">
								<el-input v-model="userDetail.basic_info.user_email" placeholder="请输入邮箱"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="6">
							<el-form-item label="生日：" :label-width="formLabelWidth">
								<el-date-picker style="width:200px;" v-model="peopleBirthday" type="date" placeholder="选择日期">
								</el-date-picker>
							</el-form-item>
						</el-col>
						<el-col :span="5">
							<el-form-item label="年龄：" :label-width="formLabelWidth">
								<el-input v-if="peopleBirthday==''" style="width:150px;" value="" disabled></el-input>
								<el-input v-else style="width:150px;" :value="$public.FAge(peopleBirthday)[0]" disabled></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="家庭住址：" :label-width="formLabelWidth">
								<el-input type="textarea" v-model="userDetail.basic_info.home_address" placeholder="请输入家庭住址"></el-input>
							</el-form-item>
						</el-col>
						<!-- <el-col :span="7">
							<el-form-item label="会员类型：" :label-width="formLabelWidth">
								<el-radio-group v-model="userDetail.basic_info.user_type">
									<el-radio :label="0">普通会员</el-radio>
									<el-radio :label="1">充值会员</el-radio>
								</el-radio-group>
							</el-form-item>
						</el-col> -->
					</el-row>
				</el-form>
			</div>
		</div>
		<div class="form" >
			<div class="tit">
				<div class="titL">押金</div>
				<div class="titR"></div>
			</div>
			<div class="con">
				<el-table :data="depositList" style="width: 100%">
					<el-table-column fixed prop="id" label="编号" width="500">
					</el-table-column>
					<el-table-column prop="name" label="服务类型">
						<template slot-scope="scope">
							{{scope.row.typeId===1?'寄养':''}}
							{{scope.row.typeId===2?'住院':''}}
						</template>
					</el-table-column>
					<el-table-column prop="deposit" label="金额" width="400">
					</el-table-column>
					<el-table-column prop="age" label="创建时间" width="400">
						<template slot-scope="scope">
							{{$public.FTime(scope.row.createTime)}}
						</template>
					</el-table-column>
					<!-- <el-table-column   label="操作" width="300">
						<template slot-scope="scope">
							<el-button type="text" size="small">查看</el-button>
							<el-button @click="edit(scope.row)" type="text" size="small">退款</el-button>
						</template>
					</el-table-column> -->
				</el-table>
			</div>
		</div>
		<!-- box3 -->
		<div class="form" >
			<div class="tit">
				<div class="titL">会员卡</div>
				<div class="titR">
					<!-- <el-button type="primary" icon="el-icon-document-add" @click="rechargeState=true">充值</el-button> -->
				</div>
			</div>
			<div class="con">
				<el-table :data="[userDetail.card_info]" style="width: 100%">
					<el-table-column prop="card_id" label="卡号" width="400">
					</el-table-column>
					<el-table-column label="类型" width="400">
						<template>
							充值卡
						</template>
					</el-table-column>
					<el-table-column label="说明">
						<template slot-scope="scope">
							余额{{scope.row.user_yue}}   赠额{{scope.row.user_zenge}}
						</template>
					</el-table-column>
					<el-table-column label="办卡地" width="400">
						<template>
							{{userDetail.company_info.shop_name}}
						</template>
					</el-table-column>
					<!-- <el-table-column label="操作" width="300">
						<template slot-scope="scope">
							<el-button type="text" size="small">查看</el-button>
							<el-button @click="edit(scope.row)" type="text" size="small">退款</el-button>
						</template>
					</el-table-column> -->
				</el-table>
			</div>
		</div>
		<div class="form">
			<div class="tit">
				<div class="titL">宠物资料</div>
				<div class="titR">
					<el-button type="primary" icon="el-icon-document-add" @click="addPet">添加</el-button>
				</div>
			</div>
			<div class="con">
				<el-table :data="userDetail.pets_info" style="width: 100%">
					<el-table-column fixed prop="date" label="编号" width="80">
						<template slot-scope="scope">
							{{scope.$index+1}}
						</template>
					</el-table-column>
					<el-table-column prop="chip_no" label="宠物芯片" width="200">
						<template slot-scope="scope">
							{{scope.row.chip_no}}
						</template>
					</el-table-column>
					<el-table-column prop="nick_name" label="昵称">
					</el-table-column>
					<el-table-column prop="class_name" label="类型" width="100">
					</el-table-column>
					<el-table-column prop="type_name" label="品种" width="200">
					</el-table-column>
					<el-table-column prop="sex" label="性别" width="100">
					</el-table-column>
					<el-table-column prop="age" label="年龄" width="200">
						<template slot-scope="scope">
							{{$public.FAge(scope.row.birth_day)[0]}}岁
							{{$public.FAge(scope.row.birth_day)[1]}}月
						</template>
					</el-table-column>
					<el-table-column prop="color" label="毛色" width="80">
					</el-table-column>
					<el-table-column prop="tool_num" label="用具编号" width="200">
					</el-table-column>
					<el-table-column   label="操作" width="200">
						<template slot-scope="scope">
							<!-- <el-button type="text" size="small" @click="$router.push({path:'/pet/petSee',query:{uid:$route.query.id,pid:scope.row._id}})">查看</el-button> -->
							<el-button @click="editPet(scope.row)" type="text" size="small">编辑</el-button>
							<el-button @click="delPet(scope.row._id)" type="text" size="small">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<el-row style="padding:30px;">
			<el-button type="primary" @click="submit">保存</el-button>
		</el-row>
		<!-- 充值弹窗 -->
		<div>
			<dialogRecharge v-if="rechargeState" @submit="dialogRechargeSubmit"></dialogRecharge>
		</div>
		<!-- 结算弹窗 -->
		<div>
			<dialogSettlement v-if="settlementState" :total="settlementTotal" @submit="dialogSettlementSubmit"></dialogSettlement>
		</div>
		<el-dialog title="宠物资料" :visible.sync="dialogFormVisible" width="65%">
			<el-form :model="form">
				<el-row>
					<el-col :span="10" :offset="1">
						<el-form-item label="昵称：" :label-width="formLabelWidth" prop="nick_name">
							<el-input v-model="form.nick_name" autocomplete="off" placeholder="请输入宠物昵称"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="10" :offset="1">
						<el-form-item label="种类：" :label-width="formLabelWidth">
							<el-radio-group v-model="form.class_name" @change="typeChange">
								<el-radio :label="'犬类'">犬</el-radio>
								<el-radio :label="'猫类'">猫</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="10" :offset="1">
						<el-form-item label="品种：" :label-width="formLabelWidth">
							<el-select class="select" filterable default-first-option v-model="form.type_name" placeholder="请选择品种">
								<el-option v-for="item in typeList" :key="item._id" :label="item.name" :value="item.name">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="10" :offset="1">
						<el-form-item label="毛色：" :label-width="formLabelWidth">
							<el-select class="select" filterable allow-create default-first-option v-model="form.color" placeholder="请选择毛色">
								<el-option v-for="item in colorList" :key="item._id" :label="item.name" :value="item.name">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="10" :offset="1">
						<el-form-item label="性别：" :label-width="formLabelWidth">
							<el-radio-group v-model="form.sex">
								<el-radio :label="'公'">公</el-radio>
								<el-radio :label="'母'">母</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
					<el-col :span="10" :offset="1">
						<el-form-item label="用品编号：" :label-width="formLabelWidth">
							<el-input v-model="form.tool_num" autocomplete="off"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="10" :offset="1" :label-width="formLabelWidth">
						<el-form-item label="出生日期：" :label-width="formLabelWidth">
							<el-date-picker :value="form.birth_day" disabled type="date" placeholder="选择日期">
							</el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="10" :offset="1">
						<el-form-item label="年龄：" :label-width="formLabelWidth">
							<el-input v-model="curPetYear" style="width:45%;margin-right: 5%;">
								<template slot="append">年</template>
							</el-input>
							<el-input v-model="curPetMonth" style="width:45%">
								<template slot="append">月</template>
							</el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="10" :offset="1">
						<el-form-item label="芯片编号：" :label-width="formLabelWidth">
							<el-input v-model="form.chip_no" autocomplete="off"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="10" :offset="1">
						<el-form-item label="其他：" :label-width="formLabelWidth">
							<el-checkbox-group v-model="checkList">
								<el-checkbox label="已绝育"></el-checkbox>
								<el-checkbox label="已免疫"></el-checkbox>
								<!-- <el-checkbox label="已驱虫"></el-checkbox> -->
							</el-checkbox-group>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="10" :offset="1">
						<el-form-item label="体重：" :label-width="formLabelWidth">
							<el-input autocomplete="off" v-model="form.weight">
								<template slot="append">kg</template>
							</el-input>
						</el-form-item>
					</el-col>
					<el-col :span="10" :offset="1">
						<el-form-item label="体重说明：" :label-width="formLabelWidth">
							<el-input type="textarea" v-model="form.weight_remark" autocomplete="off"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="10" :offset="1">
						<el-form-item label="宠物状态：" :label-width="formLabelWidth">
							<el-radio-group v-model="form.status">
								<el-radio :label="1">正常</el-radio>
								<el-radio :label="2">亡故</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
					<el-col :span="10" :offset="1" v-if="dialog_type=='addPet'">
						<el-form-item label="花生宠物：" :label-width="formLabelWidth">
							<el-radio-group v-model="form.hs_pet">
								<el-radio :label="true">是</el-radio>
								<el-radio :label="false">否</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="10" :offset="1">
						<el-form-item label="备注：" :label-width="formLabelWidth">
							<el-input type="textarea" v-model="form.remark" autocomplete="off"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="submit_Pet">确 定</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import dialogRecharge from '@/components/dialog_recharge.vue'
	import dialogSettlement from '@/components/dialog_settlement.vue'
	export default {
		components: {
			dialogRecharge,dialogSettlement
		},
		data() {
			var validateTel = (rule, value, callback) => {
				if (!this.$public.isTel(value)) {
					callback(new Error('手机号输入有误'));
				} else {
					callback();
				}
			};
			var isMail = (rule, value, callback) => {
				if (!this.$public.isMail(value)) {
					callback(new Error('邮箱输入有误'));
				} else {
					callback();
				}
			};
			return {
				rechargeState: false,
				settlementState:false,
				settlementTotal:0,
				checkList: [],
				form: {
					"nick_name": "",
					"chip_no": "",
					"class_name": "",
					"type_name": "",
					"sex": "公",
					"color": "",
					"status": 0,
					"sterilization": 0,
					"immunization": 0,
					"dewormed": 0,
					birth_day: '',
					tool_num: '',
					remark: '',
					weight:'',
					weight_remark:'',
					home_address:'',
					hs_pet:0
				},
				curPetYear:0,
				curPetMonth:0,
				typeList: [],
				colorList: [],
				radio: 3,
				depositList:[],
				
				options: [{
					value: '选项11',
					label: '黄金糕1'
				}, {
					value: '选项12',
					label: '黄金糕2'
				}, {
					value: '选项13',
					label: '黄金糕3'
				}],
				selectValue: '',
				tableData: [],
				dialogFormVisible: false,
				dialogFormVisible_recharge: false,
				formLabelWidth: '110px',
				userDetail: {
					basic_info: {},
					card_info: {},
					company_info: {},
					pets_info: []
				},
				peopleBirthday: '',
				dialog_type:'',
				rules: {
					nick_name: [{
						required: true,
						message: '请输入昵称',
						trigger: 'blur'
					}],
					user_mobile: [{
						required: true,
						validator: validateTel,
						trigger: 'blur'
					}],
					user_email: [{
						required: true,
						validator:isMail,
						trigger: 'blur'
					}],
					home_address: [{
						required: true,
						message: '请输入地址',
						trigger: 'blur'
					}],
					// birthday: [{
					// 	required: true,
					// 	message: '请选择出生日期',
					// 	trigger: 'blur'
					// }],
					// sex: [{required: true,message: '请选择会员类型',trigger: 'change'}],
				}
			}
		},
		watch:{
			curPetYear(n){
				if(!n){
					n=0
				}
				let month = parseInt(Number(n)*12+Number(this.curPetMonth));
				this.form.birth_day = this.$public.FBirthday(month)
			},
			curPetMonth(n){
				if(!n){
					n=0
				}
				let month = parseInt(Number(this.curPetYear)*12+Number(n));
				this.form.birth_day = this.$public.FBirthday(month)
			},
		},
		mounted() {
			this.getUserDetail();
			this.getColorList();
		},
		methods: {
			// 获取用户信息
			getUserDetail() {
				let params = {
					"id": this.$route.query.id,
				}
				this.$http.get('/api/Member/Single', params).then(res => {
					if (res.code == 0) {
						this.userDetail = res.data;
						this.peopleBirthday = this.userDetail.basic_info.birthday? new Date(this.userDetail.basic_info.birthday):'';
						this.getDeposit(this.userDetail._id)
					}
				})
			},
			// 获取押金
			getDeposit(memberId){
				let params = {
					"typeId": 0,
					"keyword": '',
					"startTime": '',
					"endTime": '',
					memberId:memberId,
					status: 1,     // 是否已结束（0不限；1：进行中；2：已结束）
					hasDeposit:1, // 是否有押金(0不限；1：有；2：没有)
					"pageIndex": 1,
					"pageSize": 100,
				}
				this.$http.post('/api/InHospital/List', params).then(res => {
					if (res.code == 0) {
						this.depositList = res.data.data;
					}
				})
			},
			// 切换猫狗
			typeChange(){
				this.getTypeList();
				this.form.type_name='';
			},
			// 获取品种列表
			getTypeList() {
				let params = {
					"applyType": this.form.class_name==='犬类'?2:1
				}
				this.$http.get('/api/DataCenter/PetBreedList', params).then(res => {
					if (res.code == 0) {
						this.typeList = res.data.data;
					}
				})
			},
			// 获取毛色列表
			getColorList() {
				let params = {
					"keyword": "",
					"pageIndex": 1,
					"pageSize": 1000
				}
				this.$http.post('/api/DataCenter/List', params).then(res => {
					if (res.code == 0) {
						this.colorList = res.data.data;
					}
				})
			},
			// 充值
			dialogRechargeSubmit(a) {
				console.log(a);
				this.rechargeState = false;
			},
			// 结算
			dialogSettlementSubmit(a) {
				console.log(a);
				this.settlementState = false;
			},
			// 添加宠物
			addPet() {
				this.dialog_type = 'addPet';
				this.dialogFormVisible = true;
				this.form = {
					"member_id": this.$route.query.id,
					"nick_name": "",
					"chip_no": "",
					"class_name": "犬类",
					"type_name": "",
					"sex": "公",
					"color": "",
					"status": 1,
					"sterilization": 0,
					"immunization": 0,
					"dewormed": 0,
					birth_day: '',
					tool_num: '',
					remark: '',
					weight:'',
					weight_remark:'',
					hs_pet:false
				};
				this.curPetYear = 0;
				this.curPetMonth = 0;
				this.checkList = [];
				this.getTypeList();
			},
			// 编辑宠物
			editPet(row) {
				this.dialog_type = 'editPet';
				this.dialogFormVisible = true;
				this.form = {
					"member_id": this.$route.query.id,
					"_id": row._id,
					"nick_name": row.nick_name,
					"chip_no": row.chip_no,
					"class_name": row.class_name,
					"type_name": row.type_name,
					"sex": row.sex,
					"color": row.color,
					"status": parseInt(row.status),
					"sterilization": 0,
					"immunization": 0,
					"dewormed": 0,
					birth_day: row.birth_day ? new Date(row.birth_day).getTime() : '',
					tool_num: row.tool_num,
					remark: row.remark,
					weight:row.weight,
					weight_remark:row.weight_remark,
					hs_pet:row.hs_pet
				};
				this.curPetYear = this.$public.FAge(this.form.birth_day)[0];
				this.curPetMonth = this.$public.FAge(this.form.birth_day)[1];
				this.checkList = [];
				if (row.sterilization == 1) {
					this.checkList.push("已绝育")
				}
				if (row.dewormed == 1) {
					this.checkList.push("已驱虫")
				}
				if (row.immunization == 1) {
					this.checkList.push("已免疫")
				}
				this.getTypeList();
			},
			// 删除宠物
			delPet(a){
				this.$confirm('确定要删除?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let params = {
						id:a
					}
					this.$http.get('/api/Pet/Delete', params).then(res => {
						if (res.code == 0) {
							this.getUserDetail();
							this.$message({
								message: '删除成功',
								type: 'success'
							});
						}
					})
				})
			},
			// 保存基本信息
			submit() {
				let params = {
					"id": this.$route.query.id,
					"user_mobile": this.userDetail.basic_info.user_mobile,
					"nick_name": this.userDetail.basic_info.nick_name,
					"avatar_pic": this.userDetail.basic_info.avatar_pic,
					"user_email": this.userDetail.basic_info.user_email,
					"user_address": this.userDetail.basic_info.user_address,
					"home_address": this.userDetail.basic_info.home_address,
					"sex": this.userDetail.basic_info.sex,
					birthday: this.$public.FTime(new Date(this.peopleBirthday).getTime(),'YYYY-MM-DD'),
					user_type: this.userDetail.basic_info.user_type,
				}
				this.$http.post('/api/Member/Update', params).then(res => {
					if (res.code == 0) {
						this.getUserDetail();
						this.$message({
							message: '保存成功',
							type: 'success'
						});
					}
				})
			},
			// submit添加宠物
			submit_Pet() {
				let params = {
					"member_id": this.$route.query.id,
					"nick_name": this.form.nick_name,
					"chip_no": this.form.chip_no,
					"class_name": this.form.class_name,
					"type_name": this.form.type_name,
					"sex": this.form.sex,
					"color": this.form.color,
					"status": parseInt(this.form.status),
					"sterilization": 0,
					"immunization": 0,
					"dewormed": 0,
					birth_day: this.$public.FTime(new Date(this.form.birth_day).getTime(),'YYYY-MM-DD'),
					tool_num: this.form.tool_num,
					remark: this.form.remark,
					weight:Number(this.form.weight),
					weight_remark:this.form.weight_remark,
					hs_pet:this.form.hs_pet
				}
				let s = this.checkList.join(',');
				console.log(s, s.indexOf('已绝育'))
				if (s.indexOf('已绝育') > -1) {
					params.sterilization = 1
				}
				if (s.indexOf('已驱虫') > -1) {
					params.dewormed = 1
				}
				if (s.indexOf('已免疫') > -1) {
					params.immunization = 1
				}
				if (this.dialog_type == 'addPet') {
					this.$http.post('/api/Pet/Insert', params).then(res => {
						this.dialogFormVisible = false;
						if (res.code == 0) {
							this.getUserDetail();
							this.$message({
								message: '添加成功',
								type: 'success'
							});
						}
					})
				} else {
					params._id = this.form._id;
					this.$http.post('/api/Pet/Update', params).then(res => {
						this.dialogFormVisible = false;
						if (res.code == 0) {
							this.getUserDetail();
							this.$message({
								message: '修改成功',
								type: 'success'
							});
						}
					})
				}

			},
		}
	}
</script>

<style lang="scss" scoped>
	.page {
		.form {
			padding: 0 20px;
			.tit {
				display: flex;
				justify-content: space-between;
				padding-bottom: 20px;

				.titL {
					font-size: 20px;
					color: #1A1A1A;
					border-left: 3px solid #FFD138;
					padding-left: 10px;
					line-height: 24px;
					height: 24px;
				}

				.titR {}
			}

			.con {
				padding: 0 20px 30px;
			}
		}
	}
</style>
